<template>
  <div class="blackMobile">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>客户</el-breadcrumb-item>
      <el-breadcrumb-item>黑名单管理</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="boxLayout">
      <el-form
        :inline="true"
        :model="searchForm"
        class="demo-form-inline"
      >
        <el-form-item label="手机号" class="search_keyword">
          <el-input
            placeholder="请输入手机号搜索"
            v-model="searchForm.search_keyword"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <div class="btn mg-t-10">
        <el-button type="primary" size="medium" @click="getList"
          >查询</el-button
        >
        <el-button size="medium" @click="clear">清空</el-button>
      </div>
    </div>
    <div class="boxLayout mg-t-20">
      <div class="text-right mg-b-20">
        <el-button type="primary" @click="dialogVisible = true"
          >新增</el-button
        >
      </div>
      <el-table
        ref="multipleTable"
        :data="tableData.data"
        border
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column type="index" label="序号" :align="'center'" width="80">
        </el-table-column>
        <el-table-column prop="mobile" label="手机号" :align="'center'">
        </el-table-column>
        <el-table-column prop="create_time" label="添加时间" :align="'center'">
        </el-table-column>
        <el-table-column
          label="操作"
          :align="'center'"
          width="150"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-button
              @click="handleDelete(scope.row)"
              type="text"
              size="small"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :total="tableData.total"
        :per_page="tableData.per_page"
        :current_page="tableData.current_page"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      />
    </div>
    <!-- 选择客户弹窗 -->
    <selectCustomer
      :dialogVisible="dialogVisible"
      @confirmCustomer="confirmCustomer"
      @cancel="closeSelectCustomer"
    />
  </div>
</template>
<script>
import pagination from "../../../components/pagination.vue";
import selectCustomer from "../../../components/selectCustomer.vue";
export default {
  name: "blackMobile",
  components: {
    selectCustomer,
    pagination,
  },
  data() {
    return {
      dialogVisible: false,
      searchForm: {
        search_keyword: "",
      },
      tableData: {
        data: [],
        per_page: 10,
        current_page: 1,
        total: 0,
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    clear() {
      this.searchForm.search_keyword = "";
      this.getList();
    },
    getList() {
      this.$api.blackMobile
        .getBlackMobileList({
          search_keyword: this.searchForm.search_keyword,
          page_index: this.tableData.current_page,
          page_size: this.tableData.per_page,
        })
        .then((res) => {
          this.tableData = res;
        });
    },
    closeSelectCustomer(v) {
      this.dialogVisible = v;
    },
    confirmCustomer(v) {
      if (v.length < 1) {
        this.$message.warning("请至少选择一个客户");
        return false;
      }
      let mobiles = v.map((item) => item.mobile).filter(Boolean);
      if (mobiles.length < 1) {
        this.$message.warning("所选客户没有手机号");
        return false;
      }
      this.$api.blackMobile
        .addBlackMobile({ mobile: mobiles.join(",") })
        .then(() => {
          this.$message.success("添加成功！");
          this.dialogVisible = false;
          this.getList();
        });
    },
    handleDelete(row) {
      this.$confirm("确定要移除该手机号吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$api.blackMobile.deleteBlackMobile(row.id).then(() => {
          this.$message.success("删除成功！");
          this.getList();
        });
      });
    },
    handleSizeChange(v) {
      this.tableData.per_page = v;
      this.getList();
    },
    handleCurrentChange(v) {
      this.tableData.current_page = v;
      this.getList();
    },
  },
};
</script>
<style scoped>
</style>
